////////////////////////////////////////////////////////////////
import {config} from "../config";
import http from "./httpService";
import { getIdentity } from "../components/common/commonFuncs";
const prefix = "/api/v2/institution/";

const apiEndpoint = config.apiEndpoint;
////////////////////////////////////////////////////////////////

// Institutions

export function getInstitutions() {
    return http.get(apiEndpoint + prefix + "getInstitutions", { params: { Activity_By: getIdentity() } });
}

export function addInstitution(institution) {
    return http.post(apiEndpoint + prefix + "addInstitution", {
        Institution_Name: institution.Institution_Name,
        Institution_Description: institution.Institution_Description,
        Institution_Code: institution.Institution_Code,
        Activity_By: getIdentity()
    });
}

export function updateInstitution(institution) {
    return http.post(apiEndpoint + prefix + "updateInstitution", {
        Institution_ID: institution.Institution_ID,
        Institution_Name: institution.Institution_Name,
        Institution_Description: institution.Institution_Description,
        Institution_Code: institution.Institution_Code,
        Deleted: false,
        Activity_Notes: "Institution Record Updated",
        Activity_By: getIdentity()
    });
}

export function deleteInstitution(institution) {
    return http.post(apiEndpoint + prefix + "updateInstitution", {
        Institution_ID: institution.Institution_ID,
        Institution_Name: institution.Institution_Name,
        Institution_Description: institution.Institution_Description,
        Institution_Code: institution.Institution_Code,
        Deleted: true,
        Activity_Notes: "Institution Record Deleted",
        Activity_By: getIdentity()
    });
}

// Institution User Mapping

////////////////////////////////////////////////////////////////
export function getInstitutionUserMappings() {
    return http.get(apiEndpoint + prefix + "getInstitutionUserMappings", { params: { Activity_By: getIdentity() } });
}

export function addInstitutionUserMappings(institutionUserMapping) {
    return http.post(apiEndpoint + prefix + "addInstitutionUserMapping", {
        Institution_ID: institutionUserMapping.Institution_ID,
        User_ID: institutionUserMapping.User_ID,
        Activity_By: getIdentity()
    });
}

export function updateInstitutionUserMappings(institutionUserMapping) {
    return http.post(apiEndpoint + prefix + "updateInstitutionUserMapping", {
        Institution_ID: institutionUserMapping.Institution_ID,
        User_ID: institutionUserMapping.User_ID,
        Deleted: false,
        Activity_Notes: "Institution User Mapping Record Updated",
        Activity_By: getIdentity()
    });
}

export function deleteInstitutionUserMappings(institutionUserMapping) {
    return http.post(apiEndpoint + prefix + "updateInstitutionUserMapping", {
        Institution_ID: institutionUserMapping.Institution_ID,
        User_ID: institutionUserMapping.User_ID,
        Deleted: true,
        Activity_Notes: "Institution User Mapping Deleted",
        Activity_By: getIdentity()
    });
}

// Institution User Mapping

////////////////////////////////////////////////////////////////
export function getProjectInstitutionMappings(pid) {
    return http.get(apiEndpoint + prefix + "getProjectInstitutionMappings", {
        params: {
            Project_ID: pid,
            Activity_By: getIdentity()
        },
    });
}

export function addProjectInstitutionMappings(projectInstitutionMapping) {
    return http.post(apiEndpoint + prefix + "addProjectInstitutionMapping", {
        Project_ID: projectInstitutionMapping.Project_ID,
        Institution_ID: projectInstitutionMapping.Institution_ID,
        Activity_By: getIdentity()
    });
}

export function updateProjectInstitutionMapping(projectInstitutionMapping) {
    return http.post(apiEndpoint + prefix + "updateProjectInstitutionMapping", {
        Project_ID: projectInstitutionMapping.Project_ID,
        Institution_ID: projectInstitutionMapping.Institution_ID,
        Deleted: false,
        Activity_Notes: "Project Institution Mapping Record Updated",
        Activity_By: getIdentity()
    });
}

export function deleteProjectInstitutionMapping(projectInstitutionMapping) {
    return http.post(apiEndpoint + prefix + "updateProjectInstitutionMapping", {
        Project_ID: projectInstitutionMapping.Project_ID,
        Institution_ID: projectInstitutionMapping.Institution_ID,
        Deleted: true,
        Activity_Notes: "Project Institution Mapping Deleted",
        Activity_By: getIdentity()
    });
}